import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "assetDirectory": "/",
        "title": "Magshop",
        "shortTitle": "Magshop",
        "appKey": "2ce2e4da-9f9c-43d9-9411-f842271f0e4f",
        "language": "en",
        "languages": [
            "en",
            "es"
        ],
        "buildNumber": 222093,
        "buildDate": "2025-11-25T16:54:45.941Z",
        "version": "2.10.16"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": true,
            "type": "cognito",
            "config": {
                "host": "https://auth.ami-admin.com",
                "clientId": "1qajn2tivh7ee4abd4lf531j8o"
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "magshop"
        },
        "legal": {
            "tou": {
                "url": "https://accelerate360.com/terms-and-conditions/",
                "label": "Terms of Use"
            },
            "privacy": {
                "url": "https://accelerate360.com/business-services/a360-media/privacy-policy/",
                "label": "Privacy Policy"
            },
            "cookie": {
                "url": "https://accelerate360.com/business-services/a360-media/cookie-policy/",
                "label": "Cookie Policy"
            }
        },
        "cache": {
            "ttl": {
                "getAllIssues": 1,
                "previewIssue": 1,
                "getIssue": 1,
                "getFeatureArticles": 1,
                "styles": 1
            }
        },
        "menu": {
            "externalUrl": {
                "enabled": true,
                "url": "https://magazineshop.us/",
                "title": "Magazine Shop"
            },
            "links": [
                {
                    "title": "Terms of Use",
                    "icon": "",
                    "url": "https://accelerate360.com/business-services/a360-media/terms-and-conditions/"
                },
                {
                    "title": "Do Not Sell",
                    "icon": "",
                    "url": "https://accelerate360.com/privacy-policy/"
                },
                {
                    "title": "Privacy Policy",
                    "icon": "",
                    "url": "https://accelerate360.com/business-services/a360-media/privacy-policy/"
                },
                {
                    "title": "Cookie Policy",
                    "icon": "",
                    "url": "https://accelerate360.com/business-services/a360-media/cookie-policy/"
                },
                {
                    "title": "Customer Service",
                    "icon": "",
                    "url": "https://accelerate360.com/contact/"
                }
            ]
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 0
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;